module.exports = __webpack_public_path__ + "assets/76d88450941ef9ea899908ab9e952e92.png";